import { render, staticRenderFns } from "./tiendasSimple.vue?vue&type=template&id=9dc0884a&scoped=true&"
import script from "./tiendasSimple.vue?vue&type=script&lang=js&"
export * from "./tiendasSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc0884a",
  null
  
)

export default component.exports